import { verificationQueryKeys as e } from "./useVerificationQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { verificationApi as r } from "@maat/api-main";
//#region src/verification/useUploadBusinessDocumentMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: r.uploadBusinessDocument,
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.business() });
		}
	});
};
//#endregion
export { i as useUploadBusinessDocumentMutation };
